document.addEventListener('DOMContentLoaded', function () {
    let prevScrollPos = window.pageYOffset; // Initialize variable to store the previous scroll position
    const navbar = document.getElementById('navbar');
    const menuToggle = document.getElementById('menu-toggle');
    const menuItems = document.querySelectorAll('.menu > li > a');

    function scrollFunction() {
        const currentScrollPos = window.pageYOffset; // Get the current scroll position

        // If the screen width is greater than 600 pixels, hide the navbar after 800 pixels of scrolling
        // If the screen width is less than 600 pixels, hide the navbar after 200 pixels of scrolling
        if (innerWidth > 600) {
            hideNavbar(400, currentScrollPos, prevScrollPos);
        } else {
            hideNavbar(200, currentScrollPos, prevScrollPos);
        }

        prevScrollPos = currentScrollPos; // Update the previous scroll position

        // Hide the mobile menu if the user scrolls when the menu is open
        menuToggle.checked = false;

    }

    // Attach the combined scrollFunction to the window's "scroll" event
    window.addEventListener('scroll', scrollFunction);

    // Initialize the navbar to be visible at the start
    navbar.style.top = '0';

    // Hides the mobile menu if the user clicks on a menu item
    menuItems.forEach((item) => {
        item.addEventListener('click', () => {
            menuToggle.checked = false; // Close the menu
        });
    });

    // Hides the navbar after a set amount of pixels
    // After that - shows it when scrolling up and hides it when scrolling down
    function hideNavbar(pixelAmount, currentScrollPos, prevScrollPos) {
        if (currentScrollPos > pixelAmount) {
            // Check if the user is scrolling up
            if (currentScrollPos < prevScrollPos) {
                navbar.style.top = '0'; // Show the navbar when scrolling up
            } else {
                navbar.style.top = '-104.67px'; // Hide the navbar when scrolling down
                menuToggle.checked = false; // Hide the mobile menu
            }
        } else {
            navbar.style.top = '0'; // Always show the navbar for the first set amount of pixels
        }
    }
});

//# sourceMappingURL=mobile-nav.js.map
